import React from "react";
import PropTypes from "prop-types";

const SOCIAL_LINKS = [
  { key: "fa-facebook", label: "Facebook" },
  { key: "fa-twitter", label: "Twitter / X" },
  { key: "fa-instagram", label: "Instagram" },
  { key: "fa-youtube", label: "YouTube" },
  { key: "fa-linkedin", label: "LinkedIn" },
  { key: "fa-vk", label: "VK" },
];

const SocialLinksSettings = ({ socialsData, setSocialsData, t_controls }) => {
  const handleChange = (key) => (e) => {
    const value = e.target.value;
    setSocialsData((prev) => {
      const updated = { ...prev };
      if (value.trim() === "") {
        delete updated[key];
      } else {
        updated[key] = value;
      }
      return updated;
    });
  };

  return (
    <div className="card mt-3">
      <div className="card-body">
        <h5 className="card-title">{t_controls.social_links || "Social Links"}</h5>
        <p className="text-muted small">
          {t_controls.social_links_description || "Enter URLs for the social networks you want to display. Leave blank to hide."}
        </p>

        {SOCIAL_LINKS.map(({ key, label }) => (
          <div className="form-group mt-2" key={key}>
            <label htmlFor={key}>{label}</label>
            <input
              type="url"
              className="form-control"
              id={key}
              value={socialsData[key] || ""}
              placeholder="https://..."
              onChange={handleChange(key)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

SocialLinksSettings.propTypes = {
  socialsData: PropTypes.object.isRequired,
  setSocialsData: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default SocialLinksSettings;
